import React from 'react';
import {
  Dialog, DialogTitle, DialogContent,
  Typography, IconButton, CircularProgress, Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useQuery } from 'react-query';
import ChatScreen from '../../Components/ChatScreen';
import API from '../../API';
import useIsDesktop from '../../Hooks/useIsDesktop';

export default function ChatModalCreator({ open, onClose, recipientUserId }) {
  const isDesktop = useIsDesktop();

  const { data, error, isLoading } = useQuery(
    ['creator_check_convo', recipientUserId],
    () => API.conversations.checkCreatorToUser({ recipient_user_id: recipientUserId }),
    { enabled: open && !!recipientUserId, refetchOnWindowFocus: false }
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={!isDesktop}
      PaperProps={{ sx: { minWidth: { md: '40vw' }, maxWidth: { md: '40vw' } } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6">
          {isLoading ? 'Starting chat…' : `Conversation #${data?.conversation_id}`}
        </Typography>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {error && (
          <Alert severity="error" sx={{ m: 2 }}>
            {error.response?.data?.error || error.message}
          </Alert>
        )}

        {isLoading ? (
          <CircularProgress sx={{ m: 4 }} />
        ) : (
          <ChatScreen
            conversationId={data?.conversation_id}
            showWarning={false}
            sx={{ height: '100%', minHeight: '70vh' }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
